import { DropItemCommand } from "../../core/commands/DropItemCommand";
import type { Interaction } from "../Interaction";

export const dropInteraction: Interaction = {
  id: "drop",
  label: "Drop",
  scope: "inventory",
  canExecute: (ctx) => ctx.instanceId !== undefined && ctx.position !== undefined,
  execute: async (ctx) => {
    if (!ctx.instanceId || !ctx.position) return { success: false };
    ctx.commands.execute(new DropItemCommand(ctx.instanceId, ctx.position));
    return { success: true };
  },
};
